import { Outlet, useLocation, useParams } from "react-router";
import { faUser } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AnimatePresence } from "framer-motion";
import Skeleton from "react-loading-skeleton";
import {
  faListUl,
  faFileCertificate,
  faKey,
  faIdCardClip,
} from "@fortawesome/pro-regular-svg-icons";
import { faCheck, faBan } from "@fortawesome/pro-solid-svg-icons";

import Typography from "core/components/Typography";
import { Column, Row } from "core/styles";
import Flex from "core/components/Flex";
import { SideMenuContainer, SubNav } from "modules/admin/SubNav";
import useCurrentUser from "core/hooks/useCurrentUser";

const DetailsNavigationMenu = ({ isUserFetching, user }) => {
  return (
    <SideMenuContainer>
      <SubNav
        to="general"
        icon={faListUl}
        label="General"
        statusIcon={user?.enabled ? faCheck : faBan}
        statusVariant={user?.enabled ? "success" : "default"}
        isStatusLoading={isUserFetching}
      />

      <SubNav
        to="change-password"
        icon={faKey}
        label="Password"
        isDisabled={false}
      />

      <SubNav
        to="memberships"
        icon={faIdCardClip}
        label="Memberships"
        isDisabled={false}
      />
      <SubNav
        to="credentials"
        icon={faFileCertificate}
        label="Data Credentials"
        isDisabled={false}
      />
    </SideMenuContainer>
  );
};

const UserProfileLayout = () => {
  const location = useLocation();
  const { userId } = useParams();

  if (userId.includes("@")) {
    throw Error("User profile url contains an email and is no longer valid.");
  }

  const { currentUser, isLoading } = useCurrentUser();

  // Derive values from currentUser and activeMembership
  const profileUser = currentUser;
  const isPlaceholderData = isLoading;

  return (
    <div style={{ height: "100%", position: "relative", overflow: "hidden" }}>
      <Flex direction="column">
        <AnimatePresence mode="wait">
          <Flex direction="row" minWidth="1000px">
            <Flex
              direction="column"
              width="305px"
              height="100vh"
              style={{
                backgroundColor: "#EFE9F8",
                padding: "80px 40px",
                paddingTop: "60px",
              }}
            >
              <Column gap="medium" alignItems="start">
                <Row gap="12px" alignItems="center">
                  <FontAwesomeIcon
                    icon={faUser}
                    style={{
                      width: "28px",
                      height: "28px",
                      padding: "7px 8px",
                      paddingBottom: "7px",
                      color: "#fff",
                      backgroundColor: "#00C1F3",
                      borderRadius: "5px",
                    }}
                  />
                  <div>
                    <Typography
                      variant="h4"
                      noMargin
                      style={{
                        marginBottom: "4px",
                        width: "180px",
                      }}
                    >
                      {isPlaceholderData ? (
                        <Skeleton style={{ width: "150px" }} />
                      ) : (
                        profileUser?.name
                      )}
                    </Typography>
                  </div>
                </Row>

                <DetailsNavigationMenu
                  isUserFetching={isPlaceholderData}
                  user={profileUser}
                />

                <div id="portal__devtools" />
              </Column>
            </Flex>

            <Flex
              direction="column"
              grow="1"
              style={{
                height: "100vh",
                position: "relative",
                padding: "80px 64px",
                paddingTop: "60px",
                overflowY: "auto",
              }}
            >
              <Outlet />
            </Flex>
          </Flex>
        </AnimatePresence>
      </Flex>
    </div>
  );
};

export default UserProfileLayout;
